import {Injectable} from '@angular/core';
import {ActivatedRouteSnapshot, Resolve, RouterStateSnapshot} from '@angular/router';
import {ApiService} from '../../../../utils/services/api.service';
import {Observable} from 'rxjs/Observable';

@Injectable()
export class CrossParameterResolverService implements Resolve<any> {

  constructor(private apiService: ApiService) {
  }

  resolve(route: ActivatedRouteSnapshot, state: RouterStateSnapshot): any {
    let organizationID = route.parent.params.id;

    return this.apiService.getOrganizationCrossParameters(organizationID)
      .map(response => {
        if (response['data']) {
          return response['data'].crossParameter;
        }
        return Observable.of([]);
      })
      .catch((error) => {
        return Observable.of([]);
      });
  }

}



// WEBPACK FOOTER //
// C:/Biziclick/bizisystem/src/app/main/frames/cross-parameters/resolver/cross-parameter-resolver.service.ts